module.exports = __webpack_public_path__ + "img/new-year-header.9cce7c5.jpg";